export const toMap = (x) => (x instanceof Map ? x : new Map(Object.entries(x || {})));
export const asScenarioWithMaps = (s) =>
		s && {
			...s,
			values: toMap(s.values),
			// fall back to values if originalValues not present
			originalValues: toMap(s.originalValues ?? s.values),
    		roll_up: toMap(s.roll_up),
		};
export const findEntityOrScenario = (nodeKey, entityOrScenario, scenarioEntities) => {
	const normalizedKey = nodeKey.replace(/^scenario-/, '').replace(/^entity-/, '');
	if (Array.isArray(scenarioEntities)) {
		for (let i = 0; i < scenarioEntities.length; i++) {
			const item = scenarioEntities[i];
			if (
				item.key === nodeKey || 
				String(item.scenario_id) === normalizedKey || 
				String(item.entity_id) === normalizedKey
			) {
				entityOrScenario['found'] = item;
				return;
			}
			if (item.children) {
				findEntityOrScenario(nodeKey, entityOrScenario, item.children);
			}
			if (item.scenario) {
				findEntityOrScenario(nodeKey, entityOrScenario, item.scenario);
			}
		}
	} else if (typeof scenarioEntities === 'object') {
		
		for (const key in scenarioEntities) {
			const item = scenarioEntities[key];
			
			if (
				item.key === nodeKey ||
				String(item.scenario_id) === normalizedKey ||
				String(item.entity_id) === normalizedKey
			) {
				entityOrScenario['found'] = item;
				return;
			}
			findEntityOrScenario(nodeKey, entityOrScenario, item);
		}
	}
};


//Filter helpers

export const filterEntitiesByScenarioIds = (nodes, allowed) => {
    if (!Array.isArray(nodes) || !allowed) return nodes;
    
    const walk = (n) => {
        const copy = { ...n };
        
        // Filter the raw scenario[] array (pre-tree shape, before createTreeData)
        if (Array.isArray(copy.scenario)) {
            copy.scenario = copy.scenario.filter(s => allowed.has(Number(s.scenario_id)));
        }

        // Filter children[] which may contain scenario leaves OR child entities
        if (Array.isArray(copy.children)) {
            copy.children = copy.children
                .map((child) => {
                    // Scenario leaf — include only if in the allowed set
                    if (child.scenario_id != null) {
                        return allowed.has(Number(child.scenario_id)) ? child : null;
                    }
                    // Entity node — recurse
                    return walk(child);
                })
                .filter(Boolean);
        }
        
        const hasScenarios = Array.isArray(copy.scenario) && copy.scenario.length > 0;
        const hasChildren  = Array.isArray(copy.children) && copy.children.length > 0;
        
        // Only keep this entity if it contributes at least one scenario to the BC
        return (hasScenarios || hasChildren) ? copy : null;
    };
    
    return nodes.map(walk).filter(Boolean);
};